import { Link } from 'react-router-dom';
import { siteConfig, locations } from '@/data/siteData';
import { Phone, Mail, MapPin } from 'lucide-react';

const footerLinks = {
  services: [
    { name: 'Compute', href: '/services/compute' },
    { name: 'Network & Security', href: '/services/network' },
    { name: 'Monitoring', href: '/services/monitoring' },
    { name: 'Services', href: '/services/services' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Clients', href: '/clients' },
    { name: 'Alliances', href: '/alliances' },
    { name: 'Certifications', href: '/certifications' },
    { name: 'Careers', href: '/careers' },
    { name: 'Contact', href: '/contact' },
  ],
  resources: [
    { name: 'Blog', href: '/blog' },
    { name: 'Case Studies', href: '/case-studies' },
    { name: 'FAQs', href: '/faq' },
    { name: 'Privacy Policy', href: '/privacy' },
  ],
};

export const Footer = () => {
  return (
    <footer className="bg-gray-100">
      {/* Main Footer */}
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_felix-apple/artifacts/46cryd4k_Untitled%20design%20%2845%29.png" 
                alt="Felix Infotech" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-sm text-gray-600 mb-4">
              Your trusted technology partner for {siteConfig.experience} years.
            </p>
            <div className="space-y-2">
              <a 
                href={`tel:${siteConfig.phone}`}
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#0066CC] transition-colors"
              >
                <Phone className="w-4 h-4 text-[#0066CC]" />
                {siteConfig.phone}
              </a>
              <a 
                href={`mailto:${siteConfig.email}`}
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#0066CC] transition-colors"
              >
                <Mail className="w-4 h-4 text-[#0066CC]" />
                {siteConfig.email}
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold text-gray-900 mb-4 uppercase tracking-wider">
              Services
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href}
                    className="text-sm text-gray-600 hover:text-[#0066CC] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-gray-900 mb-4 uppercase tracking-wider">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href}
                    className="text-sm text-gray-600 hover:text-[#0066CC] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-xs font-semibold text-gray-900 mb-4 uppercase tracking-wider">
              Resources
            </h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href}
                    className="text-sm text-gray-600 hover:text-[#0066CC] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h4 className="text-xs font-semibold text-gray-900 mb-4 uppercase tracking-wider">
              Locations
            </h4>
            <ul className="space-y-2">
              {locations.slice(0, 6).map((location) => (
                <li key={location.city} className="text-sm text-gray-600">
                  {location.city.split(' ')[0]}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200">
        <div className="container mx-auto px-6 py-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} Felix Infotech Pvt Ltd. All rights reserved. | Designed & Developed by{' '}
              <a href="https://anraone.com" target="_blank" rel="noopener noreferrer" className="text-[#0066CC] hover:underline">
                Anraone
              </a>
            </p>
            <div className="flex items-center gap-6">
              <Link to="/" className="text-xs text-gray-500 hover:text-[#0066CC] transition-colors">
                Home
              </Link>
              <Link to="/about" className="text-xs text-gray-500 hover:text-[#0066CC] transition-colors">
                About
              </Link>
              <Link to="/services" className="text-xs text-gray-500 hover:text-[#0066CC] transition-colors">
                Services
              </Link>
              <Link to="/contact" className="text-xs text-gray-500 hover:text-[#0066CC] transition-colors">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
